import { OpenAdminBannerStatus } from "./OpenAdminBannerStatus";

export type OpenAdminBannerParams = {
  status: OpenAdminBannerStatus;
  title: string;
  subtitle?: string;
  buttonText?: string;
  sessionLink?: string;
};

export class OpenAdminBanner {
  private readonly status: OpenAdminBannerStatus;
  private readonly title: string;
  private readonly subtitle?: string;
  private readonly buttonText?: string;
  private readonly sessionLink?: string;

  constructor({ status, title, subtitle, buttonText, sessionLink }: OpenAdminBannerParams) {
    this.status = status;
    this.title = title;
    this.subtitle = subtitle;
    this.buttonText = buttonText;
    this.sessionLink = sessionLink;
  }

  public getStatus() {
    return this.status;
  }

  public getTitle() {
    return this.title;
  }

  public getSubtitle() {
    return this.subtitle;
  }

  public getButtonText() {
    return this.buttonText;
  }

  public getSessionLink() {
    return this.sessionLink;
  }

  public isInitial() {
    return this.status === OpenAdminBannerStatus.INITIAL;
  }

  public isInProgress() {
    return this.status === OpenAdminBannerStatus.IN_PROGRESS;
  }

  public isCompleted() {
    return this.status === OpenAdminBannerStatus.COMPLETED;
  }

  public isPending() {
    return this.status === OpenAdminBannerStatus.PENDING;
  }

  public isError() {
    return this.status === OpenAdminBannerStatus.ERROR;
  }
}
